import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import TemplatesPage from "../pages/TemplatesPage";

function MainLayout() {
  return (
    <div>
      <Navbar />
      <Outlet />
      <TemplatesPage />,
    </div>
  );
}

export default MainLayout;
